<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true">
        <el-form-item label="内容类型">
          <el-radio-group v-model="mode" @change="handleModeChange">
            <el-radio-button label="job">Job</el-radio-button>
            <el-radio-button label="market">Market</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <template v-if="mode === 'job'">
          <el-form-item>
            <el-input v-model="jobFilters.jobId" placeholder="请输入 JOB ID" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="listJob">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-plus" @click="handleCreate">新建置顶</el-button>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item>
            <el-input v-model="marketFilters.topicId" placeholder="请输入 Market Topic ID" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="listMarket">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-plus" @click="handleMarketCreate">新建置顶</el-button>
          </el-form-item>
        </template>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <template v-if="mode === 'job'">
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="jobResults"
          highlight-current-row
          stripe
          border
        >
          <el-table-column prop="job_id" label="Job ID" width="100" fixed="left" />

          <el-table-column prop="start_time" label="置顶开始时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.start_time | formatDate }}
            </template>
          </el-table-column>

          <el-table-column prop="end_time" label="置顶结束时间" width="180">
            <template slot-scope="scope">
              <span :class="isExpired(scope.row.end_time) ? 'text-gray' : 'text-green'">
                {{ scope.row.end_time | formatDate }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="置顶时长（天）" width="120" align="center">
            <template slot-scope="scope">
              {{ calculateDuration(scope.row.start_time, scope.row.end_time) }}
            </template>
          </el-table-column>

          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="!isExpired(scope.row.end_time)" type="success">置顶中</el-tag>
              <el-tag v-else type="info">已过期</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)">修改</el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-else>
        <el-table
          v-loading="listLoading"
          height="100%"
          :data="marketResults"
          highlight-current-row
          stripe
          border
        >
          <el-table-column prop="topic_id" label="Topic ID" width="120" fixed="left" />

          <el-table-column prop="start_time" label="置顶开始时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.start_time | formatDate }}
            </template>
          </el-table-column>

          <el-table-column prop="end_time" label="置顶结束时间" width="180">
            <template slot-scope="scope">
              <span :class="isExpired(scope.row.end_time) ? 'text-gray' : 'text-green'">
                {{ scope.row.end_time | formatDate }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="置顶时长（天）" width="120" align="center">
            <template slot-scope="scope">
              {{ calculateDuration(scope.row.start_time, scope.row.end_time) }}
            </template>
          </el-table-column>

          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="!isExpired(scope.row.end_time)" type="success">置顶中</el-tag>
              <el-tag v-else type="info">已过期</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleMarketEdit(scope.row)">修改</el-button>
              <el-button type="danger" size="small" @click="handleMarketDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <el-dialog
        v-if="mode === 'job'"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
        :title="isCreating ? '新建置顶' : '修改置顶'"
        width="500px"
      >
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="120px">
          <el-form-item label="Job ID" prop="job_id">
            <el-input-number
              v-model="editForm.job_id"
              :disabled="!isCreating"
              :min="1"
              controls-position="right"
              style="width: 100%"
              placeholder="请输入要置顶的 Job ID"
            />
          </el-form-item>

          <el-form-item label="置顶时长（天）" prop="duration">
            <el-input-number
              v-model="editForm.duration"
              :min="1"
              :max="365"
              controls-position="right"
              style="width: 100%"
              placeholder="请输入置顶天数"
            />
            <div class="tips">置顶时长，单位：天（1-365 天）</div>
          </el-form-item>

          <el-form-item label="快速选择时长">
            <el-button-group>
              <el-button size="small" @click="setDuration(1)">1天</el-button>
              <el-button size="small" @click="setDuration(3)">3天</el-button>
              <el-button size="small" @click="setDuration(5)">5天</el-button>
              <el-button size="small" @click="setDuration(7)">1周</el-button>
            </el-button-group>
          </el-form-item>

          <el-form-item v-if="!isCreating" label="开始时间">
            <span>{{ editForm.start_time | formatDate }}</span>
          </el-form-item>

          <el-form-item v-if="!isCreating" label="结束时间">
            <span>{{ calculateEndTime() | formatDate }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button :loading="editLoading" type="primary" @click="submitForm">
            {{ isCreating ? "创建" : "保存" }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        v-if="mode === 'market'"
        :visible.sync="marketEditFormVisible"
        :close-on-click-modal="false"
        :title="marketIsCreating ? '新建置顶' : '修改置顶'"
        width="500px"
      >
        <el-form
          ref="marketEditForm"
          :model="marketEditForm"
          :rules="marketEditFormRules"
          label-width="120px"
        >
          <el-form-item label="Market Topic ID" prop="topic_id">
            <el-input-number
              v-model="marketEditForm.topic_id"
              :disabled="!marketIsCreating"
              :min="1"
              controls-position="right"
              style="width: 100%"
              placeholder="请输入要置顶的 Market Topic ID"
            />
          </el-form-item>

          <el-form-item label="置顶时长（天）" prop="duration">
            <el-input-number
              v-model="marketEditForm.duration"
              :min="1"
              :max="365"
              controls-position="right"
              style="width: 100%"
              placeholder="请输入置顶天数"
            />
            <div class="tips">置顶时长，单位：天（1-365 天）</div>
          </el-form-item>

          <el-form-item label="快速选择时长">
            <el-button-group>
              <el-button size="small" @click="setMarketDuration(1)">1天</el-button>
              <el-button size="small" @click="setMarketDuration(3)">3天</el-button>
              <el-button size="small" @click="setMarketDuration(5)">5天</el-button>
              <el-button size="small" @click="setMarketDuration(7)">1周</el-button>
            </el-button-group>
          </el-form-item>

          <el-form-item v-if="!marketIsCreating" label="开始时间">
            <span>{{ marketEditForm.start_time | formatDate }}</span>
          </el-form-item>

          <el-form-item v-if="!marketIsCreating" label="结束时间">
            <span>{{ calculateMarketEndTime() | formatDate }}</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="marketEditFormVisible = false">取消</el-button>
          <el-button :loading="marketEditLoading" type="primary" @click="submitMarketForm">
            {{ marketIsCreating ? "创建" : "保存" }}
          </el-button>
        </div>
      </el-dialog>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="currentPage.page"
        :page-size="currentPage.limit"
        :total="currentPage.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import { formatDate } from "../../../../filters";

export default {
  filters: {
    formatDate,
  },
  data() {
    return {
      mainHeight: "300px",
      mode: "job",
      listLoading: false,

      jobResults: [],
      jobPage: {
        page: 1,
        limit: 20,
        total: 0,
      },
      jobFilters: {
        jobId: "",
      },

      editFormVisible: false,
      editLoading: false,
      isCreating: false,
      editForm: {
        id: 0,
        job_id: null,
        start_time: 0,
        end_time: 0,
        duration: 7,
      },
      editFormRules: {
        job_id: [
          { required: true, message: "请输入 Job ID", trigger: "blur" },
          { type: "number", min: 1, message: "Job ID 必须大于 0", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入置顶时长", trigger: "blur" },
          { type: "number", min: 1, max: 365, message: "时长范围为 1-365 天", trigger: "blur" },
        ],
      },

      marketResults: [],
      marketPage: {
        page: 1,
        limit: 20,
        total: 0,
      },
      marketFilters: {
        topicId: "",
      },

      marketEditFormVisible: false,
      marketEditLoading: false,
      marketIsCreating: false,
      marketEditForm: {
        id: 0,
        topic_id: null,
        start_time: 0,
        end_time: 0,
        duration: 7,
      },
      marketEditFormRules: {
        topic_id: [
          { required: true, message: "请输入 Market Topic ID", trigger: "blur" },
          { type: "number", min: 1, message: "Market Topic ID 必须大于 0", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入置顶时长", trigger: "blur" },
          { type: "number", min: 1, max: 365, message: "时长范围为 1-365 天", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    currentPage() {
      return this.mode === "job" ? this.jobPage : this.marketPage;
    },
  },
  mounted() {
    mainHeight(this);
    this.listJob();
  },
  methods: {
    handleModeChange() {
      this.editFormVisible = false;
      this.marketEditFormVisible = false;
      if (this.mode === "job") {
        this.listJob();
      } else {
        this.listMarket();
      }
    },
    isExpired(endTime) {
      if (!endTime) return true;
      return endTime * 1000 < Date.now();
    },
    calculateDuration(startTime, endTime) {
      if (!startTime || !endTime) return 0;
      const durationMs = (endTime - startTime) * 1000;
      return Math.ceil(durationMs / (1000 * 60 * 60 * 24));
    },
    buildEndTime(startTime, duration) {
      return startTime + duration * 24 * 60 * 60;
    },
    calculateEndTime() {
      const startTime = this.isCreating ? Math.floor(Date.now() / 1000) : this.editForm.start_time;
      return this.buildEndTime(startTime, this.editForm.duration);
    },
    calculateMarketEndTime() {
      const startTime = this.marketIsCreating
        ? Math.floor(Date.now() / 1000)
        : this.marketEditForm.start_time;
      return this.buildEndTime(startTime, this.marketEditForm.duration);
    },
    handlePageChange(val) {
      if (this.mode === "job") {
        this.jobPage.page = val;
        this.listJob();
      } else {
        this.marketPage.page = val;
        this.listMarket();
      }
    },
    handleLimitChange(val) {
      if (this.mode === "job") {
        this.jobPage.limit = val;
        this.listJob();
      } else {
        this.marketPage.limit = val;
        this.listMarket();
      }
    },

    listJob() {
      this.listLoading = true;
      const params = {
        page: this.jobPage.page,
        limit: this.jobPage.limit,
      };
      if (this.jobFilters.jobId) {
        params.job_id = this.jobFilters.jobId;
      }
      this.axios
        .form("/api/admin/job-top/list", params)
        .then((data) => {
          this.jobResults = data.results || [];
          this.jobPage = data.page || { page: 1, limit: 20, total: 0 };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleCreate() {
      this.isCreating = true;
      this.editForm = {
        id: 0,
        job_id: null,
        start_time: 0,
        end_time: 0,
        duration: 7,
      };
      this.editFormVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    handleEdit(row) {
      this.isCreating = false;
      this.editForm = {
        id: row.id,
        job_id: row.job_id,
        start_time: row.start_time,
        end_time: row.end_time,
        duration: this.calculateDuration(row.start_time, row.end_time) || 7,
      };
      this.editFormVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    setDuration(days) {
      this.editForm.duration = days;
    },
    handleDelete(row) {
      this.$confirm("确定要删除这个置顶设置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios.form("/api/admin/job-top/delete", { id: row.id }).then(() => {
            this.$notify.success({ title: "成功", message: "删除成功" });
            this.listJob();
          });
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        const startTime = this.isCreating ? Math.floor(Date.now() / 1000) : this.editForm.start_time;
        const params = {
          job_id: this.editForm.job_id,
          start_time: startTime,
          end_time: this.buildEndTime(startTime, this.editForm.duration),
        };
        if (!this.isCreating) {
          params.id = this.editForm.id;
        }
        const apiUrl = this.isCreating ? "/api/admin/job-top/create" : "/api/admin/job-top/update";
        this.editLoading = true;
        this.axios
          .form(apiUrl, params)
          .then(() => {
            this.$notify.success({
              title: "成功",
              message: this.isCreating ? "创建成功" : "修改成功",
            });
            this.editFormVisible = false;
            this.listJob();
          })
          .catch((err) => {
            this.$notify.error({
              title: "错误",
              message: err.message || (this.isCreating ? "创建失败" : "修改失败"),
            });
          })
          .finally(() => {
            this.editLoading = false;
          });
      });
    },

    listMarket() {
      this.listLoading = true;
      const params = {
        page: this.marketPage.page,
        limit: this.marketPage.limit,
      };
      if (this.marketFilters.topicId) {
        params.topic_id = this.marketFilters.topicId;
      }
      this.axios
        .form("/api/admin/market-top/list", params)
        .then((data) => {
          this.marketResults = data.results || [];
          this.marketPage = data.page || { page: 1, limit: 20, total: 0 };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleMarketCreate() {
      this.marketIsCreating = true;
      this.marketEditForm = {
        id: 0,
        topic_id: null,
        start_time: 0,
        end_time: 0,
        duration: 7,
      };
      this.marketEditFormVisible = true;
      this.$nextTick(() => {
        this.$refs.marketEditForm && this.$refs.marketEditForm.clearValidate();
      });
    },
    handleMarketEdit(row) {
      this.marketIsCreating = false;
      this.marketEditForm = {
        id: row.id,
        topic_id: row.topic_id,
        start_time: row.start_time,
        end_time: row.end_time,
        duration: this.calculateDuration(row.start_time, row.end_time) || 7,
      };
      this.marketEditFormVisible = true;
      this.$nextTick(() => {
        this.$refs.marketEditForm && this.$refs.marketEditForm.clearValidate();
      });
    },
    setMarketDuration(days) {
      this.marketEditForm.duration = days;
    },
    handleMarketDelete(row) {
      this.$confirm("确定要删除这个置顶设置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios.form("/api/admin/market-top/delete", { id: row.id }).then(() => {
            this.$notify.success({ title: "成功", message: "删除成功" });
            this.listMarket();
          });
        })
        .catch(() => {});
    },
    submitMarketForm() {
      this.$refs.marketEditForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        const startTime = this.marketIsCreating
          ? Math.floor(Date.now() / 1000)
          : this.marketEditForm.start_time;
        const params = {
          topic_id: this.marketEditForm.topic_id,
          start_time: startTime,
          end_time: this.buildEndTime(startTime, this.marketEditForm.duration),
        };
        if (!this.marketIsCreating) {
          params.id = this.marketEditForm.id;
        }
        const apiUrl = this.marketIsCreating
          ? "/api/admin/market-top/create"
          : "/api/admin/market-top/update";
        this.marketEditLoading = true;
        this.axios
          .form(apiUrl, params)
          .then(() => {
            this.$notify.success({
              title: "成功",
              message: this.marketIsCreating ? "创建成功" : "修改成功",
            });
            this.marketEditFormVisible = false;
            this.listMarket();
          })
          .catch((err) => {
            this.$notify.error({
              title: "错误",
              message: err.message || (this.marketIsCreating ? "创建失败" : "修改失败"),
            });
          })
          .finally(() => {
            this.marketEditLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.text-gray {
  color: #909399;
}

.text-green {
  color: #67c23a;
  font-weight: bold;
}

.tips {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
